// src/components/Common/ErrorBoundary.js

import React from 'react';
import PropTypes from 'prop-types';
import { ToastContext } from '../../contexts/ToastContext';

/**
 * ErrorBoundary component catches JavaScript errors in its child component tree.
 */
class ErrorBoundary extends React.Component {
  static contextType = ToastContext;

  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state to display fallback UI
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    if (this.context && this.context.addToast) {
      this.context.addToast("Something went wrong. Please try again later.", "error");
    }
  }

  render() {
    if (this.state.hasError) {
      // Render fallback UI
      return (
        <div className="flex flex-col items-center justify-center min-h-screen bg-gradient-to-b from-primary to-secondary text-white">
          <h1 className="text-4xl font-bold mb-4">Oops!</h1>
          <p className="text-lg mb-8">Something went wrong.</p>
          <button
            onClick={() => window.location.reload()}
            className="bg-accentBlue text-white py-2 px-4 rounded-lg shadow-md hover:bg-accentBlueDark transition-colors duration-200"
          >
            Reload Page
          </button>
        </div>
      );
    }

    return this.props.children; 
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ErrorBoundary;
